import React from "react";
import SuperAdminRoute from "./SuperAdminRoute";
import MerchantRoute from "./MerchantRoute";
import MerchantEmployeeRoute from "./MerchantEmployeeRoute";
import StoreAdminRoute from "./StoreAdminRoute";

function AllRoute({ module }) {
  return (
    <>
      {module === "merchant" ? (
        <MerchantRoute />
      ) : module === "store-admin" ? (
        <StoreAdminRoute />
      ) : module === "superadmin" ? (
        <SuperAdminRoute />
      ) : module === "merchant-employee" ? (
        <MerchantEmployeeRoute />
      ) : (
        ""
      )}
    </>
  );
}

export default AllRoute;
